export const types = {
	login: '[auth] login',
	signup: '[auth] signup',
	logout: '[auth] logout',
	hasToken: '[auth] hastoken',

	getCompany: '[company] getCompany',
	addCompany: '[company] addCompany',
	companyUpdate: '[company] companyUpdate',
	companyDelete: '[company] companyDelete',

	getPosts: '[post] getPosts',
	getThisPost: '[post] getThisPost',
	addPost: '[post] addPost',
	postUpdate: '[post] postUpdate',
	postCategoriesUpdate: '[post] postCategoriesUpdate',

	addSection: '[Section] addSection',
	getSections: '[Section] getSections',
	sectionUpdate: '[Section] sectionUpdate',
	deleteSection: '[Section] deleteSection',
	updateThis: '[Section] updateThis',

	getMaquinas: '[Maquina] getMaquina',
	getThisMaquinas: '[Maquina] getThisMaquina',
	updateThisMaquinas: '[Maquina] updateThisMaquinas',
	addMaquina: '[Maquina] addMaquina',
	maquinaUpdate: '[Maquina] MaquinaUpdate',
	maquinaDelete: '[Maquina] MaquinaDelete',
	featuresUpdate: '[Maquina] featuresUpdate',
	galleryUpdate: '[Maquina] galleryUpdate',
};
